import setBroadcasts from './setBroadcasts';
import saveFilters from '../filters/saveFilters';
import clearOverrideFilters from '../media/clearOverrideFilters';
import getBroadcastNames from './getBroadcastNames';
import setIsReturningFromOverride from '../media/setIsReturningFromOverride';
import sendNotification from '../notifications/send';

import combineActions from '../../utils/combineActions';

export default combineActions({
    setBroadcasts,
    getBroadcastNames,
    clearOverrideFilters,
    saveFilters,
    setIsReturningFromOverride,
    sendNotification,
});
